import { useQuery } from '@tanstack/react-query';
import { OrgQueryKeys } from '../config';
import { ResourceType } from 'harmony-constants';
import { Downtime } from '../../types';

export const useDowntimeQuery = (resourceType: ResourceType, resourceId: number, companyId: number) => {
    // @ts-ignore
    const queryKey = OrgQueryKeys.resolveDowntime(companyId, OrgQueryKeys[resourceType], resourceId);

    return useQuery<Downtime[]>([queryKey]);
};
